import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';

import router from './router';
import theme from './lib/styles/theme';
import Fonts from './lib/styles/fonts';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container);

root.render(
  <RecoilRoot>
    <HelmetProvider>
      <QueryClientProvider client={client}>
        <ChakraProvider theme={theme}>
          <Fonts />
          <RouterProvider router={router} />
        </ChakraProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </RecoilRoot>
);
